<script setup>
import { nextTick, watch } from 'vue';
import QRCode from 'qrcode';
import { useTireSetStore } from '@/stores/tireSet';
import { storeToRefs } from 'pinia';

const { current } = storeToRefs(useTireSetStore());

let printed = false;

watch(current, async (value) => {
    if (!value || printed) {
        return;
    }
    printed = true;
    await nextTick();

    const canvases = document.querySelectorAll('canvas[data-payload]');
    for (const canvas of canvases) {
        await QRCode.toCanvas(canvas, canvas.dataset.payload, {
            width: 120,
            margin: 1,
            errorCorrectionLevel: 'H',
        });
    }
    window.print();
}, { immediate: true });
</script>

<template>
<div
    v-if="current"
    class="bg-white text-black p-6">
    <div class="grid grid-cols-2 gap-4">
        <div
            v-for="tire in current.tires"
            :key="tire.barcode"
            class="border border-black/40 rounded-lg p-4 flex gap-4 items-center break-inside-avoid">
            <canvas :data-payload="tire.barcode" />
            <div class="min-w-0">
                <p class="font-mono font-bold text-sm">{{ tire.barcode }}</p>
                <p class="text-sm font-semibold truncate">{{ current.customer_name }}</p>
                <p class="text-xs truncate">{{ current.vehicle_label }}</p>
                <p class="font-mono text-xs">{{ [tire.position, tire.size, current.season].filter(Boolean).join(' · ') }}</p>
            </div>
        </div>
    </div>
</div>
</template>

<style scoped>
@media print {
    .break-inside-avoid {
        break-inside: avoid;
    }
}
</style>
